import state from '@bingads-webui-component-legacy/state/index';
import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';
import _ from 'underscore';
import { queryify } from '@bingads-webui/url-util';

export function fetchProductDataForAudienceShoppingCampaignCreationPage(serverContext) {
  let url = queryify('/Campaign/NewCampaign/GetProductScope', {
    aid: state.get('account_id'),
    cid: state.get('customer_id'),
    uid: state.get('user_id'),
    salesCountry: 'US',
  });

  if (serverContext.Permissions.IsEnhancedPAFilterP2Enabled) {
    url = queryify(url, {
      getCategoryFullData: true,
      getProductTypeFullData: true,
    });
  }

  const params = {
    url,
    adapter: 'legacy',
    bypassCache: false,
    cacheResponse: true,
  };

  const p = jsdata.Product.find('AudienceMetaData', params);
  return p;
}

const $top = 10000;

export const fetchFeedDataForAudienceShoppingCampaignCreationPage = (serverContext) => {
  const query = {
    $filter: 'Status eq Enum.FeedStatus\'Active\' and FeedCategories/any(c:c eq Enum.FeedCategory\'DynamicData\')',
    // set a large number so that we don't miss any feed
    $top,
    $skip: 0,
  };

  const supportedFeedTypeForDynamicDataFeedCamapign = {
    DynamicDataAutosListingFeed: 'DynamicDataAutosListingFeed',
    DynamicDataEventsFeed: 'DynamicDataEventsFeed',
    DynamicDataHotelsAndVacationRentalsFeed: 'DynamicDataHotelsAndVacationRentalsFeed',
    DynamicDataToursAndActivitiesFeed: 'DynamicDataToursAndActivitiesFeed',
  };

  if (_.result(serverContext.Permissions, 'IsCuriseFeedForAudienceCampaignEnabled')) {
    supportedFeedTypeForDynamicDataFeedCamapign.DynamicDataCruisesFeed = 'DynamicDataCruisesFeed';
  }

  const p = jsdata.Feed.findAll({
    query,
  }).then(data => _.reject(data, item =>
    !supportedFeedTypeForDynamicDataFeedCamapign[item.FeedType]));
  return p;
};
